import { z } from 'zod';

const file = z
  .object({
    id: z.string().min(1).optional(),
    name: z.string().min(1),
    size: z.number(),
  })
  .passthrough();

const payload = z.string().refine((data) => {
  try {
    return JSON.parse(data);
  } catch {
    return false;
  }
});

export const workItemDetailSchema = z.object({
  payload: z.preprocess((data) => (data === '' ? undefined : data), payload.nullish()),
  files: file.array().optional(),
});

export type WorkItemDetailForm = z.infer<typeof workItemDetailSchema>;

export const formatPayload = (itemPayload?: unknown): string =>
  itemPayload ? JSON.stringify(itemPayload, null, 2) : '';
